/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, Row, Col
} from 'antd';

import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import history from '../../../services/history.js';
import { AddOrUpdateMasterData, DeleteMasterDetails, getMasterListFromDatabase } from '../../../redux/Trackrecord/saga.js';
import CommonAGGridTable from '../../AG Grid/CommonAGGridTable.js';


const { TabPane } = Tabs;
const { Title, Text } = Typography;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const MasteForm = (props) => {

    const {
        setIsMasterModalVisible,
        isMasterModalVisible,
        selectedTap
    } = props;

    const dataSource = [
        {
            key: '1',
            partNumber: 'C235418',
            description: 'HOLDER,TOOL PIGGY-BACK   5 DEG, 110 OFFS',
            quantity_5000_Welds: 1,
            category: 'BEVELLING',
            multiple_item: 'Yes',
            cost: '23',
            where_Used: 'BD4 BEV-CBUC-HW',
            UOM: 'EA',
            alternate_Parts: 'F2M0044-R',
            // Add other properties as needed
        },
    ]
    const [UpdateModalForm] = Form.useForm()

    const [searchText, setSearchText] = useState({});
    const [searchedColumn, setSearchedColumn] = useState('');

    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [currentPagesize, setCurrentPagesize] = useState(10);

    const [masterUploadForm] = Form.useForm()
    const [addNewForm] = Form.useForm()
    const [disableFileUpload, setDisableFileUpload] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [bulkUplaodModal, setBulkUplaodModal] = useState(false);
    const [databaseList, setDatabaseList] = useState([]);
    const [showAddNewModal, setShowAddNewModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editRecord, seteditRecord] = useState('');

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [matrialClassTypes, setMatrialClassTypes] = useState([]);
    const [selectedMatrialClass, setSelectedMatrialClass] = useState('');

    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isDeleteLoading, setIsDeleteLoading] = useState(false)
    const [activeKey, setActiveKey] = useState('1')
    const [activeKeyLine, setActiveKeyLine] = useState('1')
    const [searchCriteria, setSearchCriteria] = useState({});
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);

    const [addLoading, setAddLoading] = useState(false)
    const [loading, setLoading] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [isUpdateLoading, setUpdateLoading] = useState(false)
    const [addItem, setAddItem] = useState('');

    const [columnDefs, setColumnDefs] = useState([])
    const [layoutSave, setLayoutSave] = useState(false);
    const [layoutLoad, setLayoutLoad] = useState(false);
    const [isPivotMode, setIsPivotMode] = useState(false);
    const [rowData, setRowData] = useState([])
    const [gridApi, setGridApi] = useState(null);
    const [loadingProgress, setLoadingProgress] = useState(0);


    const generateColumns = (title, dataIndex) => {
        console.log(title, dataIndex)
        const columnDefs = [

            {
                headerName:title,
                field: dataIndex,
                width: 200,
                sortable: true,
                filter: true,
                headerClass: 'ag-center-header',

                cellStyle: { textAlign: 'left' },
                suppressMovable: true,
                filter: 'agMultiColumnFilter',
                filterParams: {
                    filters: [
                        {
                            filter: 'agTextColumnFilter',
                            filterParams: {
                                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                                buttons: ['reset'],
                            }
                        },
                        {
                            filter: 'agSetColumnFilter',
                            filterParams: {
                                buttons: ['reset'],
                            }
                        }
                    ]
                },
            },
            {
                headerName: 'Actions',
                field: 'editDelete',
                width: 200,
                pinned: 'right',
                suppressMovable: true,
                headerClass: 'ag-center-header',
                cellRenderer: (params) => {
                    const record = params.data;
                    return (
                        <div>
                        <Tooltip title="Update">
                            <span className="icon-18 mr-2 cursor-pointer edit-hover">
                                <EditOutlined style={{ fontSize: '18px' }}
                                    onClick={() => onUpdateClick(record)}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <span className="icon-18 mr-2 cursor-pointer edit-hover" style={{ marginLeft: '20px' }}>
                                <DeleteOutlined style={{ fontSize: '18px' }}
                                    onClick={() => showDeleteModal(record)}
                                />
                            </span>
                        </Tooltip>
                    </div>

                    );
                },
                cellStyle: { textAlign: 'center' },
                filter: false,
                suppressMovable: true,
            },
            // {
            //     headerName: 'Maintenance',
            //     field: 'maintenance',
            //     width: 200,
            //     cellRenderer: (params) => {
            //         const record = params.data;
            //         return (
            //             <div className='tableIcons'>
            //                 <Button
            //                     className='maintenance_mng_Btn'
            //                     onClick={() => {
            //                         setChecksOpen(true);
            //                         setOpenPage('maintenance');
            //                         setEquipmentTypeName(record.pihEquipmentType);
            //                         equipTypeSearchForm.setFieldsValue({
            //                             equipmentType: record.pihEquipmentType
            //                         });
            //                     }}
            //                 >
            //                     Maintenance Management
            //                 </Button>
            //             </div>
            //         );
            //     },
            //     cellStyle: { textAlign: 'center' },
            //     filter: false,
            //     suppressMovable: true,
            // },

        ];

        // console.log(columnList, columnDefs);
        setColumnDefs(columnDefs);
        return columnDefs;
    };
 

  
    const [data_List, setData_List] = useState({});


    const tableNames = {
        countries_List: 'Country',
        diameters: 'Diameter',
        saleContracts: 'Sale Contract',
        projecttypes: 'Project type',
        rootBeadTypes: 'Root Bead Type',
        externalEquipments: 'External Equipment',
        weldingProcesses: 'Welding Process',
        powerSupplies: 'Power Supply',
        wireTypes: 'Wire Type',
        terrains: 'Terrain',
        climates: 'Climate',
        positions: 'Position',
        inspectionTypes: 'Inspection Type',
        materials: 'Material'
    };

    const coulumNames = {
        countries_List: 'country',
        diameters: 'diameter',
        saleContracts: 'sale_contract',
        projecttypes: 'type',
        rootBeadTypes: 'root_bead_type',
        externalEquipments: 'external_equipment',
        weldingProcesses: 'welding_process',
        powerSupplies: 'power_supply',
        wireTypes: 'wireType',
        terrains: 'terrain',
        climates: 'climate',
        positions: 'position',
        inspectionTypes: 'inspection_type',
        materials: 'material'
    };

    useEffect(() => {
        (async () => {
            if (data_List)
                setLoading(true)
            const response = await getMasterListFromDatabase();
            if (response) {
                setData_List(response);
                console.log('Record Item', response);

                // Set the initial selected material class
                const initialClass = Object.keys(tableNames)[0];
                setSelectedMatrialClass(initialClass);
                setActiveKeyLine(initialClass);
                handleTabChange(initialClass)
                setLoading(false)
            }
        })();
    }, []);

    const handleTabChange = async (key) => {
        setLoading(true)
        setActiveKeyLine(key);
        setSelectedMatrialClass(key);
        await generateColumns(tableNames[key], coulumNames[key])
        setLoading(false)
        console.log(key)
    };

    const handleUpdateOk = async () => {

        UpdateModalForm
            .validateFields()
            .then(async (data) => {
                if (editRecord) {
                    setUpdateLoading(true)
                    const obj = {
                        columnName: coulumNames[activeKeyLine],
                        tableName: activeKeyLine,
                        data: {
                            [coulumNames[activeKeyLine]]: data[coulumNames[activeKeyLine]],
                            ID: editRecord.ID
                        }
                    };
                    console.log(obj);
                    // Uncomment and implement this function
                    await AddOrUpdateMasterData(obj)
                    setUpdateLoading(false)
                    setEditModalVisible(false)
                    setLoading(true)
                    await UpdateMasterList();
                    setLoading(false)

                }
            });


    };

    const onUpdateClick = (record) => {

        if (record) {
            //UpdateModalForm.resetFields()

            UpdateModalForm.setFieldsValue(record)
            setAddItem(record[activeKeyLine])
            console.log(record)
            seteditRecord(record)
            setEditModalVisible(true)
        }

    }

    const handleCancel = async () => {


        setEditModalVisible(false)
        UpdateModalForm.resetFields()
    };

    const handleAddCancel = async () => {


        setShowAddNewModal(false)
        UpdateModalForm.resetFields()
    };
    const getPipelineTabpanes = () => {


        return (
            <div className="custom-tab h-100" style={{ paddingTop: '10px' }}>
                <Tabs activeKey={selectedMatrialClass} onChange={handleTabChange} defaultActiveKey={Object.keys(tableNames)[0]}>
                    {Object.keys(tableNames).map((row) => (
                        <TabPane tab={tableNames[row]} key={row}>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <div className='addTeamDetails'>
                                       
                                        <CommonAGGridTable
                                            rowData={data_List[row] || []}
                                            columnDefs={columnDefs}
                                            activeKeyLine="example-grid"
                                            isRawListLoading={data_List[row]?.length === 0 || loading}
                                            loadingMessage={`Loading ${row} List...`}
                                        />
                                    </div>


                                </Col>
                            </Row>
                        </TabPane>
                    ))}
                </Tabs>
            </div>
        );
    };
    const handleCreateNew = () => {
        addNewForm
            .validateFields()
            .then(async (data) => {


                if (addItem == '') {
                    notification.warning({
                        message: 'Enter the category class to proceed!'
                    });
                    return
                }
                console.log(addItem)
                setAddLoading(true)
                const obj = {
                    columnName: coulumNames[activeKeyLine],
                    tableName: activeKeyLine,
                    data: {
                        [coulumNames[activeKeyLine]]: addItem
                    }
                };
                console.log(obj);
                // Uncomment and implement this function
                await AddOrUpdateMasterData(obj)
                setAddLoading(false)
                setShowAddNewModal(false);
                setLoading(true)
                await UpdateMasterList();
                setLoading(false)
            })
            .catch(errorInfo => {
                console.error('Validation failed:', errorInfo);
            });
    };

    /** Display Confirmation while deleting */
    const showDeleteModal = (record) => {
        setIsDeleteModalVisible(true);
        setSelectedData(record)
    };
    /** Deleting Spare parts data on confirm */
    const handleDeleteOk = async () => {
        setIsDeleteLoading(true)
        const obj = {
            columnName: coulumNames[activeKeyLine],
            tableName: activeKeyLine,
            data: selectedData
        };
        console.log(obj);
        await DeleteMasterDetails(obj)
        setIsDeleteLoading(false)
        setIsDeleteModalVisible(false);

        setSelectedData('');
        setLoading(true)
        await UpdateMasterList();
        setLoading(false)




    }

    const UpdateMasterList = async () => {
        const response = await getMasterListFromDatabase();
        if (response) {
            setData_List(response);
            console.log('Record Item', response);

            // Set the initial selected material class
            //const initialClass = Object.keys(tableNames)[0];
            setSelectedMatrialClass(activeKeyLine);
            setActiveKeyLine(activeKeyLine);
        }
    }
    /** Cancelling the deletion of spare parts data */
    const handleDeleteCancel = () => {
        setIsDeleteModalVisible(false);
    }

    return (

        <div>
            <div className="d-flex mb-3 align-items-center">
                <div className='back_equip' >
                    <Tooltip title={'Back'} >
                        <ArrowLeftOutlined onClick={() => {

                            setIsMasterModalVisible(false)
                        }} />
                    </Tooltip>
                </div>

                <Title className="mb-0 add-new-calibration" level={3} style={{ paddingLeft: '25px', paddingTop: '5px' }}>
                   {selectedTap} Confguration
                </Title>

                <div className="new-calibration">

                    {/* <Button shape="round" key="apply" type="primary" onClick={handleDownloadTemplate} loading={downloadLoading}>
                        Download Master List
                    </Button> */}

                    <Text onClick={() => setShowAddNewModal(true)} className="ps-3 add-new-calibration" >
                        <span className="icon-22" style={{ scale: '20px' }}>
                            <svg>
                                <use xlinkHref="#add" />
                            </svg>
                        </span>
                        Add New
                    </Text>

                </div>

            </div>
            <div className="custom-line" />
            {getPipelineTabpanes()}

            {/* {
                showAddNewModal &&
                <MasterAddnew
                    showAddNewModal={showAddNewModal}
                    setShowAddNewModal={setShowAddNewModal}
                    addNewForm={addNewForm}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    editRecord={editRecord}
                    seteditRecord={seteditRecord}
                >

                </MasterAddnew>
            } */}
            <Modal width="30vw"
                className="pipeline-modal"
                title='Update'
                centered
                visible={editModalVisible}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="apply" type="primary" onClick={handleUpdateOk} loading={isUpdateLoading}>
                        {isUpdateLoading ? 'Updating' : 'Update'}
                    </Button>
                ]}
            >
                <Form
                    form={UpdateModalForm}
                    name="basic"
                    layout="vertical"
                    autoComplete="off"
                >
                    <Row gutter={16}>
                        <Col lg={20}>
                            <Form.Item
                                name={coulumNames[activeKeyLine]}
                                label={tableNames[activeKeyLine]}
                            //required
                            >
                                <Input style={{ height: '35px' }} onChange={(e) => setAddItem(e.target.value)} />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>

            </Modal>
            <Modal width="30vw"
                className="pipeline-modal"
                title='Add New'
                centered
                visible={showAddNewModal}
                footer={[
                    <Button key="cancel" onClick={handleAddCancel}>
                        Cancel
                    </Button>,
                    <Button key="apply" type="primary" onClick={handleCreateNew} loading={addLoading}>
                        {showAddNewModal ? 'Add' : 'Adding'}
                    </Button>
                ]}
            >
                <Form
                    form={addNewForm}
                    name="basic"
                    layout="vertical"
                    autoComplete="off"
                >
                    <Row gutter={16}>
                        <Col lg={20}>
                            <Form.Item
                                name={coulumNames[activeKeyLine]}
                                label={tableNames[activeKeyLine]}
                            //required
                            >
                                <Input style={{ height: '35px' }} onChange={(e) => setAddItem(e.target.value)} />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>

            </Modal>

            <Modal
                width="45vw"
                className="pipeline-modal"
                title="Delete  Details"
                centered
                visible={isDeleteModalVisible}
                footer={[
                    <Button key="cancel" onClick={handleDeleteCancel}>
                        Cancel
                    </Button>,
                    <Button key="apply" type="primary" onClick={handleDeleteOk} loading={isDeleteLoading}>
                        {isDeleteLoading ? 'Deleting' : 'Delete'}
                    </Button>
                ]}
            >
                <div>
                    <Text style={{ fontSize: '16px' }}>
                        <p>Deleting all the corresponding and related information.</p>
                        Are you sure you want to delete  ?</Text>
                </div>
            </Modal>

        </div>
    );
};



export default connect(null, null)(MasteForm);

